import { ProblemOrdersAnalyticsTotalsSchema } from "@redotech/redo-analytics-common/analytics";
import { StandardCarrier } from "@redotech/redo-fulfillment-carrier-common/carrier-service-enums";
import { SupportedCarrier } from "@redotech/redo-order-tracking-settings-common/carriers/supported-carrier";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getProblemOrdersAnalytics = {
  name: "getProblemOrdersAnalytics",
  input: z.object({
    numUnits: z.number().positive(),
    startDate: z.date(),
    problemType: z.string(),
    /** StandardCarrier labels for v1 teams, SupportedCarrier codes for v2 */
    carrier: z.union([
      z.literal("all"),
      createEnum(StandardCarrier),
      createEnum(SupportedCarrier),
    ]),
  }),
  output: ProblemOrdersAnalyticsTotalsSchema,
};
